// extracted by mini-css-extract-plugin
export default {"container":"onfido-sdk-ui-CustomFileInput-container","input":"onfido-sdk-ui-CustomFileInput-input"};